// extracted by mini-css-extract-plugin
module.exports = {"table":"PaymentProductsTable_table__2CC-K","total":"PaymentProductsTable_total__2hcQx"};